import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { getQueryParam, getRedirectQueryParam } from './shared/utilities';
Vue.use(VueI18n);

window.languages = ['en', 'de', 'zh'];

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

const currentLang = getQueryParam('lang');
const token = getQueryParam('token');
const redirectURL = getRedirectQueryParam();
let defaultLang;
if (window.languages.indexOf(currentLang) !== -1) {
  // has language in url
  defaultLang = currentLang;
} else {
  // fetch browser default language
  const browserlanguage = (navigator.language || navigator.userLanguage).split('-')[0];
  // use english, if browser language isnt from the supported language
  defaultLang = window.languages.indexOf(browserlanguage) !== -1 ? browserlanguage : 'en';
}
const searchParams = new URLSearchParams();
searchParams.set('lang', defaultLang);

if(redirectURL)
  searchParams.set('redirect', encodeURIComponent(redirectURL));

if(token)
  searchParams.set('token', token);

window.history.replaceState(null, null, `?${searchParams.toString()}`); // replace url without postback

export default new VueI18n({
  locale: defaultLang,
  fallbackLocale: 'en',
  messages: loadLocaleMessages()
});
